/* eslint-disable no-underscore-dangle */

import { isEqual, isNil, isArray, isString, isEmpty, isObject, isFunction, cloneDeep, omit, pick, get } from 'lodash';

// define a mixin object
export default {
  autosave: [],

  timers: {
    __autosave: {
      time: 1000,
      autostart: true,
      repeat: true,
    },
  },

  data: function () {
    return {
      __lastRunData: {},
      __saveInProgress: {},
      __pausedSaves: {},
    };
  },

  created: function () {
    this.__saveInProgress = {};
    this.__pausedSaves = {};
    this.$serviceBus.$on('autosave', this.__autosave);
    this.__autosave();
  },

  mounted: function () {
    this.__autosave();
  },

  beforeRouteLeave(to, from, next) {
    this.__autosave();
    next();
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('autosave', this.__autosave);
    this.__autosave();
  },

  methods: {
    __pauseAutosave(name) {
      this.__pausedSaves[name] = true;
    },
    __continueAutosave(name) {
      this.__updateLastRunData();
      this.__pausedSaves[name] = false;
    },
    __autosave() {
      if (isArray(this.$options.autosave)) {
        this.__updateLastRunData();
      }
    },
    __updateLastRunData() {
      const lastRunData = {};
      this.__loopAutosaveOptions((it) => {
        const val = this[it.variable];

        if (!isEmpty(val)) {
          if (!isEmpty(it.exclude) && !isEmpty(it.include)) {
            lastRunData[it.name] = omit(pick(cloneDeep(val), it.include), it.exclude);
          } else if (!isEmpty(it.exclude) && isEmpty(it.include)) {
            lastRunData[it.name] = omit(cloneDeep(val), it.exclude);
          } else if (!isEmpty(it.include) && isEmpty(it.exclude)) {
            lastRunData[it.name] = pick(cloneDeep(val), it.include);
          } else if (isEmpty(it.include) && isEmpty(it.exclude)) {
            lastRunData[it.name] = cloneDeep(val);
          }
        } else {
          lastRunData[it.name] = null;
        }
      });

      // we need to build the lastRunData before checking for any changes to ensure that we don't miss any changes between triggering save and building the last run data

      if (!isEmpty(this.__lastRunData)) {
        this.__loopAutosaveOptions((it) => {
          if (get(this.__saveInProgress, it.name, false) === true) {
            // make sure the change detection does trigger again next time
            lastRunData[it.name] = this.__lastRunData[it.name];
          } else if (!isEmpty(this.__lastRunData[it.name]) && !isEmpty(this[it.variable])) {
            if (!isEmpty(it.exclude) && !isEmpty(it.include) && !isEqual(this.__lastRunData[it.name], omit(pick(this[it.variable], it.include), it.exclude))) {
              this.__doSave(it);
            } else if (!isEmpty(it.exclude) && isEmpty(it.include) && !isEqual(this.__lastRunData[it.name], omit(this[it.variable], it.exclude))) {
              this.__doSave(it);
            } else if (!isEmpty(it.include) && isEmpty(it.exclude) && !isEqual(this.__lastRunData[it.name], pick(this[it.variable], it.include))) {
              this.__doSave(it);
            } else if (isEmpty(it.exclude) && isEmpty(it.include) && !isEqual(this.__lastRunData[it.name], this[it.variable])) {
              this.__doSave(it);
            }
          }
        });
      }

      this.__lastRunData = lastRunData;
    },
    __doSave(it) {
      if (this.__pausedSaves[it.name] === true) return;

      const $vm = this;

      this.__saveInProgress[it.name] = true;
      this.$store.commit('save/started', this._uid);
      const callback = () => {
        $vm.$store.commit('save/finished', this._uid);
        $vm.__saveInProgress[it.name] = false;
        if (!isEmpty(it.event)) {
          $vm.$serviceBus.$emit(it.event);
        }
      };
      try {
        it.fn.call(this, callback);
      } catch (e) {
        this.$rollbar.error(e);
        this.axios.post(this.$serviceUrls.log.error, { error: e, user: this.$root.username, url: window.location.href, hotel: this.$root.hotel, date: new Date().toISOString() });
        this.showErrorMessage('Beim Speichern ist ein unerwarteter Fehler aufgetreten.');
        console.error(e);
        // to make sure we are not stuck in the save pending state
        callback();
      }
    },
    __loopAutosaveOptions(fn) {
      this.$options.autosave.forEach((it) => {
        if (isObject(it) && isString(it.name) && isString(it.variable) && isFunction(it.fn)) {
          fn(it);
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/SaveWatchMixin.js